import { DIDRoutingType } from './did-routing-type.enum';

export const ROUTING_OPTIONS: {
  value: DIDRoutingType;
  labelKey: string;
  disabled?: boolean;
}[] = [
  { value: DIDRoutingType.AiAgent, labelKey: 'Settings::PhoneNumbers:Routing:AiAgent' },
  {
    value: DIDRoutingType.Queue,
    labelKey: 'Settings::PhoneNumbers:Routing:QueueComingSoon',
    disabled: true,
  },
  {
    value: DIDRoutingType.SpecificAgent,
    labelKey: 'Settings::PhoneNumbers:Routing:SpecificAgentComingSoon',
    disabled: true,
  },
];
